import { render, staticRenderFns } from "./StockDashboard.vue?vue&type=template&id=b2acb53e&"
import script from "./StockDashboard.vue?vue&type=script&lang=js&"
export * from "./StockDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports